const habitActionTypes = {
  SET_HABITS: "SET_HABITS",
};

export default habitActionTypes;
